import {
  createSlice,
  createAsyncThunk,
  AsyncThunk, PayloadAction
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
  LoginResponse,
  AuthProject,
  UserData
} from "../../types/auth.types";

export const initialAuthState: LoginResponse & {
  loading: boolean,
  error?: any,
  login?: string
} = {
  userToken: "",
  isProjectAdmin: false,
  isTestToolAdmin: false,
  loading: false,
  projects: [] as Array<AuthProject>,
}

const baseUrl = process.env.REACT_APP_SERVER_NAME as string;

export const loginUser: AsyncThunk<LoginResponse, UserData, any> = createAsyncThunk(
  'auth/loginUser',
  async (userData: UserData, { rejectWithValue }) => {
    try {
      const response = await axios.post<LoginResponse>(`${baseUrl}/auth/login`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue((error as any).response.data);
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    logout: (state) => {
      state.projects = [];
      state.userToken = "";
      state.isProjectAdmin = false;
      state.isTestToolAdmin = false;
      state.error = undefined;
    },
    setLogin: (state, action: PayloadAction<string>) => {
      state.login = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isProjectAdmin = action.payload.isProjectAdmin;
        state.isTestToolAdmin = action.payload.isTestToolAdmin;
        state.userToken = action.payload.userToken;
        state.projects = action.payload.projects;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  logout,
  setLogin
} = authSlice.actions;
export default authSlice.reducer;